import { unavailableOnWeb } from './unavailableOnWeb.web';
export const pick = unavailableOnWeb('DocumentPicker.pick');
export const keepLocalCopy = unavailableOnWeb('DocumentPicker.keepLocalCopy');
